var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempleSingleCarousel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 252.526,
    height: 275,
    viewBox: "0 0 252.526 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #79bd9a;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: #f95e5a;\n      }\n\n      .cls-7 {\n        fill: #ef4136;\n      }\n\n      .cls-8 {\n        fill: #fbb040;\n      }\n\n      .cls-9 {\n        fill: #f7941e;\n      }\n\n      .cls-10 {\n        fill: #be1e2d;\n      }\n\n      .cls-11 {\n        fill: #e07c0e;\n      }\n\n      .cls-12 {\n        fill: #e02722;\n      }\n\n      .cls-13 {\n        fill: #a50f21;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17339",
    "data-name": "Rectangle 17339",
    className: "cls-1",
    width: 252.526,
    height: 275
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11661",
    "data-name": "Path 11661",
    className: "cls-1",
    d: "M486.77,2745.458c.84,3.172,5.716,6.552,22.9,6.309,31.921-.45,75.384.633,76.936,6.688s34.908,4.837,60.894,6.045c19.638.913,50-5.647,50.128-11.157v-.071c-.042-1.754-3.177-3.4-10.732-4.656-31.3-5.207-70.915-7.829-110.88-7.83a811.25,811.25,0,0,0-89.246,4.67",
    transform: "translate(-486.77 -2740.788)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.198,
    y1: 1.64,
    x2: -0.197,
    y2: 1.64,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183b4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11660",
    "data-name": "Path 11660",
    className: "cls-3",
    d: "M241.794,2748.618c-65.611-10.917-167.727-10.47-233.13,1.667-7.458,1.384-24.442,9.449,27.979,11.865s84.674,3.925,60.505,8.152-.6,10.723,31.527,10.874c32.266.151,85.241-8.182,74.248-9.731-27.452-3.868-26.511-8.152-.525-6.944s70.745-10.668,39.4-15.883",
    transform: "translate(0 -2506.179)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375",
    transform: "translate(41.667 234.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17340",
    "data-name": "Rectangle 17340",
    className: "cls-5",
    width: 210.859,
    height: 24.626,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11662",
    "data-name": "Path 11662",
    className: "cls-6",
    d: "M1152.17,1770.356l-76.56-1.418-.19,60.286h76.6Z",
    transform: "translate(-983.365 -1617.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11663",
    "data-name": "Path 11663",
    className: "cls-7",
    d: "M1077.081,1784.087l37.273,45.139h39.186l.149-58.868-76.56-1.418Z",
    transform: "translate(-984.884 -1617.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11664",
    "data-name": "Path 11664",
    className: "cls-8",
    d: "M1330.641,1981.245s6.693-4.834,0-11.9c0,0,3.347-6.507-2.231-10.04q-8.159-5.167-11.013-10.235v-.257c-.023.043-.048.086-.071.129-.024-.043-.048-.086-.072-.129v.257q-2.855,5.053-11.013,10.235c-5.577,3.533-2.231,10.04-2.231,10.04-6.693,7.065,0,11.9,0,11.9a11.615,11.615,0,0,0-3.161,12.457l16.4,2.4v.021l.072-.01.071.01v-.021l16.4-2.4a11.615,11.615,0,0,0-3.161-12.457",
    transform: "translate(-1188.901 -1781.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11665",
    "data-name": "Path 11665",
    className: "cls-7",
    d: "M1390.812,2052.594c-3.875,6.134-10.095,7.62-10.25,17.12v18.87h20.5v-18.87c-.154-9.5-8.328-11.359-10.249-17.12",
    transform: "translate(-1262.387 -1876.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11666",
    "data-name": "Path 11666",
    className: "cls-9",
    d: "M1344.2,1981.245s6.693-4.834,0-11.9c0,0,3.347-6.507-2.231-10.04q-8.159-5.167-11.013-10.235v-.257c-.023.043-.048.086-.071.129-.024-.043-.049-.086-.072-.129v.257q-2.855,5.053-11.013,10.235c-5.578,3.533-2.231,10.04-2.231,10.04a11.391,11.391,0,0,0-2.545,3.883l16.905,20.473h15.43a11.615,11.615,0,0,0-3.161-12.457",
    transform: "translate(-1202.456 -1781.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11667",
    "data-name": "Path 11667",
    className: "cls-10",
    d: "M1390.812,2052.594c-3.875,6.134-10.095,7.62-10.25,17.12v5.206l11.283,13.664h9.216v-18.87c-.154-9.5-8.328-11.359-10.249-17.12",
    transform: "translate(-1262.387 -1876.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11668",
    "data-name": "Path 11668",
    className: "cls-7",
    d: "M1530.3,1.737s10.957-3.9,19.323,0S1567.753,0,1567.753,0a17.581,17.581,0,0,1-10.877,7.5s3.719,3.254,10.226.744a18.22,18.22,0,0,1-18.8,2.559c-9.092-3.953-18.017.881-18.017.881Z",
    transform: "translate(-1399.297 -0.002)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17341",
    "data-name": "Rectangle 17341",
    className: "cls-10",
    width: 1.092,
    height: 31.979,
    transform: "translate(129.9 0.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11669",
    "data-name": "Path 11669",
    className: "cls-9",
    d: "M1190.2,615.785c-28.752,0-31.223,97.729-31.223,97.729h62.445s-2.471-97.729-31.222-97.729",
    transform: "translate(-1059.77 -563.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11670",
    "data-name": "Path 11670",
    className: "cls-11",
    d: "M1221.423,1613.443s-.135-5.323-.707-13.485c-21.479,11.738-46.094,11.358-61.581,9.409-.119,2.594-.157,4.076-.157,4.076h62.445Z",
    transform: "translate(-1059.77 -1463.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11671",
    "data-name": "Path 11671",
    className: "cls-7",
    d: "M1226.1,738.9c-25.657,0-27.861,87.21-27.861,87.21h55.723s-2.2-87.21-27.861-87.21",
    transform: "translate(-1095.67 -675.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11672",
    "data-name": "Path 11672",
    className: "cls-6",
    d: "M1109.272,879.1H1078.05s1.383-54.667,14.109-82.229c-19.868,10.413-21.685,82.254-21.685,82.254h53.358s0-.01,0-.026Z",
    transform: "translate(-978.842 -728.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11673",
    "data-name": "Path 11673",
    className: "cls-12",
    d: "M1385.3,796.87c12.726,27.561,14.109,82.229,14.109,82.229h-45.782c0,.015,0,.026,0,.026h53.358s-1.817-71.841-21.684-82.254",
    transform: "translate(-1237.755 -728.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11674",
    "data-name": "Path 11674",
    className: "cls-13",
    d: "M1406.982,1565.659s-.19-7.492-1.115-17.986a72.326,72.326,0,0,1-7.167,4.476c.572,8.161.707,13.484.707,13.484h-45.782c0,.015,0,.026,0,.026h53.358Z",
    transform: "translate(-1237.755 -1415.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11675",
    "data-name": "Path 11675",
    className: "cls-9",
    d: "M1384,977.263c-3.56,19.29-13.08,25.536-13.08,49.4,0,6.539,5.856,11.839,13.08,11.839s13.08-5.3,13.08-11.839c0-23.86-9.519-30.107-13.08-49.4",
    transform: "translate(-1253.57 -893.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11676",
    "data-name": "Path 11676",
    className: "cls-7",
    d: "M1449.647,1139.632c-1.372-4.009-3.693-4.589-5.328-6.963s4.062-2.69,4.167-4.22-5.4-3.667-5.908-5.644c-.592-2.284,4.244-2.954,4.009-6.541-.191-2.92-4.932-12.555-4.932-12.555s-4.741,9.635-4.932,12.555c-.235,3.587,4.6,4.257,4.009,6.541-.512,1.977-6.013,4.114-5.908,5.644s5.8,1.846,4.167,4.22-3.957,2.954-5.328,6.963,1.161,13.029,7.49,14.084a3.208,3.208,0,0,0,1,0c6.33-1.055,8.862-10.075,7.491-14.084",
    transform: "translate(-1310.612 -1009.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11677",
    "data-name": "Path 11677",
    className: "cls-6",
    d: "M1550.689,1338.629c-.75-1.082-3.275-2.377-4.711-3.678.966,1.262,3.416,2.552,4.711,3.678",
    transform: "translate(-1413.643 -1220.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11678",
    "data-name": "Path 11678",
    className: "cls-6",
    d: "M1570.876,1452.744c-.722-.826-1.49-1.443-2.21-2.153.692.8,1.461,1.412,2.21,2.153",
    transform: "translate(-1434.389 -1326.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11679",
    "data-name": "Path 11679",
    className: "cls-6",
    d: "M1444.556,1311.325a.645.645,0,0,1-.032-.158c-.106-1.529,5.4-3.667,5.908-5.644.206-.8-.247-1.4-.914-1.991a1.515,1.515,0,0,1,.3,1.341c-.512,1.977-6.013,4.115-5.908,5.644.021.31.272.57.645.808",
    transform: "translate(-1320.312 -1191.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11680",
    "data-name": "Path 11680",
    className: "cls-6",
    d: "M1427.117,1428.994c1.371-4.009,3.692-4.589,5.328-6.963a1.194,1.194,0,0,0-.417-1.872,1.158,1.158,0,0,1-.2,1.222c-1.635,2.374-3.956,2.954-5.328,6.963-1.024,3,.13,8.787,3.42,11.965-2.817-3.267-3.765-8.514-2.807-11.315",
    transform: "translate(-1304.065 -1298.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11681",
    "data-name": "Path 11681",
    className: "cls-6",
    d: "M1467.472,1111.834a3.48,3.48,0,0,1-.837-2.515c.171-2.609,3.974-10.579,4.781-12.246-.286-.6-.462-.958-.462-.958s-4.741,9.635-4.932,12.555a3.829,3.829,0,0,0,1.45,3.165",
    transform: "translate(-1340.524 -1002.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11682",
    "data-name": "Path 11682",
    className: "cls-7",
    d: "M1441.823,365.8c2.03-.629,4.254-2.61,3.335-5.221s-7.879-11.215-7.879-11.215-6.961,8.6-7.88,11.215,1.305,4.592,3.336,5.221,1.354,2.95-.87,3.892,5.414.41,5.414.41,7.638.531,5.414-.41-2.9-3.264-.87-3.892",
    transform: "translate(-1306.849 -319.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17342",
    "data-name": "Rectangle 17342",
    className: "cls-9",
    width: 109.242,
    height: 3.815,
    rx: 1.908,
    transform: "translate(75.809 150.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11683",
    "data-name": "Path 11683",
    className: "cls-10",
    d: "M993.008,1769.92H887.484a1.865,1.865,0,0,1-1.637-.98,1.845,1.845,0,0,0-.223.879v.1a1.865,1.865,0,0,0,1.859,1.859H993.008a1.865,1.865,0,0,0,1.859-1.859v-.1a1.842,1.842,0,0,0-.223-.879,1.864,1.864,0,0,1-1.636.98",
    transform: "translate(-809.816 -1617.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11684",
    "data-name": "Path 11684",
    className: "cls-9",
    d: "M1503.637,1148.049c-.535,3.2-1.967,4.243-1.967,8.207a1.967,1.967,0,0,0,3.934,0c0-3.964-1.432-5-1.967-8.207",
    transform: "translate(-1373.128 -1049.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11685",
    "data-name": "Path 11685",
    className: "cls-8",
    d: "M1502.483,1157.07c0-3.393,1.049-4.643,1.687-6.943a12.669,12.669,0,0,1-.534-2.079c-.535,3.2-1.967,4.243-1.967,8.207a1.966,1.966,0,0,0,1.045,1.737,1.956,1.956,0,0,1-.23-.923",
    transform: "translate(-1373.127 -1049.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11686",
    "data-name": "Path 11686",
    className: "cls-9",
    d: "M1483.536,1511.965a4.246,4.246,0,1,1-4.246-4.246,4.246,4.246,0,0,1,4.246,4.246",
    transform: "translate(-1348.78 -1378.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11687",
    "data-name": "Path 11687",
    className: "cls-8",
    d: "M1476.2,1512.4a4.247,4.247,0,0,1,5.144-4.151,4.246,4.246,0,1,0-2.95,7.868,4.245,4.245,0,0,1-2.194-3.717",
    transform: "translate(-1348.78 -1378.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11688",
    "data-name": "Path 11688",
    className: "cls-8",
    d: "M1158.978,730.714h18.2c.366-4.208-1.612-8.92-3.936-12.36-4.834-7.158-4.369-21.66-.93-29.655s4.648-16.175,4.81-28.632,4.393-18.035,6.531-20.638c1.925-2.343,1.664-3.244.441-4.834-23,12.681-25.114,96.119-25.114,96.119",
    transform: "translate(-1059.77 -580.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11689",
    "data-name": "Path 11689",
    className: "cls-9",
    d: "M1436.75,357.1c-1.642,2.065-6.585,8.381-7.349,10.552-.918,2.61,1.305,4.592,3.336,5.221s1.354,2.95-.87,3.892c-.807.342-.314.49.641.539.655-.295,1.334-.538,1.84-.74,1.663-.665,3.171-2.124,1.045-4.355s-2.43-2.51-1.221-7.437a58.4,58.4,0,0,1,2.579-7.671",
    transform: "translate(-1306.85 -326.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11690",
    "data-name": "Path 11690",
    className: "cls-9",
    d: "M1213.02,844.187a45.126,45.126,0,0,1,.814-8.236c-14.15,21.786-15.595,78.9-15.595,78.9h14.835c.374-4.213-1.607-8.934-3.934-12.379-4.834-7.158-4.369-21.66-.93-29.655s4.648-16.175,4.81-28.632",
    transform: "translate(-1095.67 -764.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11691",
    "data-name": "Path 11691",
    className: "cls-10",
    d: "M1392.731,586.639c0,1.651-6.057,2.989-13.529,2.989s-13.529-1.338-13.529-2.989,6.057-2.989,13.529-2.989,13.529,1.338,13.529,2.989",
    transform: "translate(-1248.772 -533.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11692",
    "data-name": "Path 11692",
    className: "cls-7",
    d: "M1376.268,584.483c-6.06.3-10.595,1.49-10.595,2.918,0,1.238,3.4,2.3,8.257,2.754a7.377,7.377,0,0,0-1.277-1.939c-1.579-1.965,1.951-3.067,3.615-3.732",
    transform: "translate(-1248.772 -534.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11693",
    "data-name": "Path 11693",
    className: "cls-8",
    d: "M1474.972,790.461h-4.105v-3.839h4.105a.4.4,0,1,0,0-.763h-4.486a.453.453,0,0,0-.382.5v4.1h-3.838v-4.1a.4.4,0,1,0-.764,0v4.487a.453.453,0,0,0,.5.382h4.1v3.839H1466a.4.4,0,1,0,0,.763h4.487a.452.452,0,0,0,.381-.5v-4.1h3.839v4.1a.4.4,0,1,0,.763,0v-4.487a.453.453,0,0,0-.5-.382",
    transform: "translate(-1340.055 -718.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11694",
    "data-name": "Path 11694",
    className: "cls-8",
    d: "M1540.9,864.687a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-1407.567 -789.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11695",
    "data-name": "Path 11695",
    className: "cls-8",
    d: "M1488.241,864.687a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-1359.414 -789.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11696",
    "data-name": "Path 11696",
    className: "cls-8",
    d: "M1540.9,809.19a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-1407.567 -739.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11697",
    "data-name": "Path 11697",
    className: "cls-8",
    d: "M1488.241,809.19a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-1359.414 -739.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11698",
    "data-name": "Path 11698",
    className: "cls-9",
    d: "M972.871,2484H859.085l18.592-10.784h76.6Z",
    transform: "translate(-785.548 -2261.515)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17343",
    "data-name": "Rectangle 17343",
    className: "cls-10",
    width: 113.786,
    height: 19.218,
    transform: "translate(73.537 222.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11699",
    "data-name": "Path 11699",
    className: "cls-9",
    d: "M1008.37,1456.265c1.68-.521,3.521-2.161,2.761-4.322s-6.522-9.283-6.522-9.283-5.762,7.122-6.522,9.283,1.08,3.8,2.761,4.322,1.12,2.442-.72,3.221,4.481.34,4.481.34,6.322.44,4.481-.34-2.4-2.7-.72-3.221",
    transform: "translate(-912.49 -1319.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11700",
    "data-name": "Path 11700",
    className: "cls-8",
    d: "M1005.219,1465.265c2.789-3.161-2.6-5.485-2.789-9.3a17.213,17.213,0,0,1,1.745-6.983c-1.352,1.7-5.455,6.941-6.088,8.741-.76,2.161,1.08,3.8,2.761,4.322s1.12,2.442-.72,3.221,4.481.34,4.481.34l.274.018c.112-.116.224-.235.336-.362",
    transform: "translate(-912.49 -1324.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11701",
    "data-name": "Path 11701",
    className: "cls-10",
    d: "M966.01,1634.784c-9.6,0-10.312,1.482-10.312,3.31v7.245h20.624v-7.245c0-1.828-.469-3.31-10.312-3.31",
    transform: "translate(-873.892 -1494.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11702",
    "data-name": "Path 11702",
    className: "cls-7",
    d: "M961.424,1640.922c-.363-3.068,2.408-2.6,5.2-5.764a4.223,4.223,0,0,0,.291-.37q-.437,0-.9,0c-9.6,0-10.312,1.482-10.312,3.31v7.245h7.739c-.6-1.528-1.855-3.071-2.014-4.417",
    transform: "translate(-873.892 -1494.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11703",
    "data-name": "Path 11703",
    className: "cls-9",
    d: "M981.948,1939.1c-3.719-10.639-1.921-24.552-1.921-24.552H968.741s1.8,13.913-1.921,24.552-1.24,14.322,0,16.5c1.089,1.917,6.311,1.939,7.564,1.917,1.253.023,6.475,0,7.564-1.917,1.24-2.183,3.718-5.865,0-16.5",
    transform: "translate(-882.265 -1750.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11704",
    "data-name": "Path 11704",
    className: "cls-8",
    d: "M970.267,1942.287c-2.976-5.392,6.694-18.22,2.645-22.412a11.765,11.765,0,0,1-3.264-5.33h-.906s1.8,13.913-1.921,24.552-1.24,14.322,0,16.5c.943,1.661,4.988,1.9,6.867,1.919.2-.522.429-1.061.7-1.62,3.188-6.654-1.143-8.22-4.118-13.612",
    transform: "translate(-882.266 -1750.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11705",
    "data-name": "Path 11705",
    className: "cls-10",
    d: "M966.01,2443.52c-9.6,0-10.312,1.631-10.312,3.643v7.973h20.624v-7.973c0-2.012-.469-3.643-10.312-3.643",
    transform: "translate(-873.892 -2234.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11706",
    "data-name": "Path 11706",
    className: "cls-12",
    d: "M964.607,2443.67c-8.266.155-8.908,1.721-8.908,3.63v7.973h10.312c-1-3.97-2.394-7.185-1.4-11.6",
    transform: "translate(-873.892 -2234.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11707",
    "data-name": "Path 11707",
    className: "cls-10",
    d: "M966.011,1813.828c9.6,0,10.312-1.631,10.312-3.642v-7.973H955.7v7.973c0,2.012.468,3.642,10.312,3.642",
    transform: "translate(-873.892 -1647.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11708",
    "data-name": "Path 11708",
    className: "cls-12",
    d: "M955.7,1810.185c0,1.69.331,3.111,6.273,3.522-1.4-2.737-1.008-5.081.851-6.674,1.5-1.284,1.271-3.322.81-4.821H955.7Z",
    transform: "translate(-873.892 -1647.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11709",
    "data-name": "Path 11709",
    className: "cls-7",
    d: "M979.652,1922.924c0,1.338-4.463,2.424-9.968,2.424s-9.968-1.086-9.968-2.424,4.463-2.423,9.968-2.423,9.968,1.085,9.968,2.423",
    transform: "translate(-877.565 -1756.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11710",
    "data-name": "Path 11710",
    className: "cls-6",
    d: "M968.211,1928.132a12.936,12.936,0,0,1-3.042-4.557c-3.235.4-5.452,1.217-5.452,2.16,0,1.217,3.688,2.224,8.494,2.4",
    transform: "translate(-877.566 -1758.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11711",
    "data-name": "Path 11711",
    className: "cls-7",
    d: "M979.652,2400.084c0,1.338-4.463,2.423-9.968,2.423s-9.968-1.085-9.968-2.423,4.463-2.423,9.968-2.423,9.968,1.085,9.968,2.423",
    transform: "translate(-877.565 -2192.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11712",
    "data-name": "Path 11712",
    className: "cls-6",
    d: "M959.716,2400.084c0,1.208,3.638,2.21,8.4,2.393a17.458,17.458,0,0,1,1.571-4.817c-5.505,0-9.968,1.085-9.968,2.423",
    transform: "translate(-877.565 -2192.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11713",
    "data-name": "Path 11713",
    className: "cls-9",
    d: "M1903.493,1456.265c1.68-.521,3.521-2.161,2.761-4.322s-6.522-9.283-6.522-9.283-5.761,7.122-6.522,9.283,1.081,3.8,2.761,4.322,1.12,2.442-.72,3.221,4.481.34,4.481.34,6.322.44,4.481-.34-2.4-2.7-.72-3.221",
    transform: "translate(-1730.991 -1319.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11714",
    "data-name": "Path 11714",
    className: "cls-8",
    d: "M1900.343,1465.265c2.789-3.161-2.6-5.485-2.789-9.3a17.214,17.214,0,0,1,1.746-6.983c-1.352,1.7-5.455,6.941-6.089,8.741-.76,2.161,1.081,3.8,2.761,4.322s1.12,2.442-.72,3.221,4.482.34,4.482.34l.274.018c.112-.116.224-.235.336-.362",
    transform: "translate(-1730.992 -1324.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11715",
    "data-name": "Path 11715",
    className: "cls-10",
    d: "M1861.135,1634.784c-9.6,0-10.312,1.482-10.312,3.31v7.245h20.623v-7.245c0-1.828-.468-3.31-10.312-3.31",
    transform: "translate(-1692.394 -1494.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11716",
    "data-name": "Path 11716",
    className: "cls-7",
    d: "M1856.549,1640.922c-.363-3.068,2.408-2.6,5.2-5.764a4.157,4.157,0,0,0,.291-.37q-.437,0-.9,0c-9.6,0-10.312,1.482-10.312,3.31v7.245h7.739c-.6-1.528-1.855-3.071-2.014-4.417",
    transform: "translate(-1692.395 -1494.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11717",
    "data-name": "Path 11717",
    className: "cls-9",
    d: "M1877.071,1939.1c-3.719-10.639-1.921-24.552-1.921-24.552h-11.286s1.8,13.913-1.921,24.552-1.24,14.322,0,16.5c1.089,1.917,6.311,1.939,7.564,1.917,1.253.023,6.475,0,7.564-1.917,1.24-2.183,3.719-5.865,0-16.5",
    transform: "translate(-1700.766 -1750.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11718",
    "data-name": "Path 11718",
    className: "cls-8",
    d: "M1865.389,1942.287c-2.976-5.392,6.694-18.22,2.645-22.412a11.763,11.763,0,0,1-3.264-5.33h-.906s1.8,13.913-1.921,24.552-1.24,14.322,0,16.5c.943,1.661,4.988,1.9,6.867,1.919.2-.522.429-1.061.7-1.62,3.188-6.654-1.142-8.22-4.118-13.612",
    transform: "translate(-1700.766 -1750.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11719",
    "data-name": "Path 11719",
    className: "cls-10",
    d: "M1861.135,2443.52c-9.6,0-10.312,1.631-10.312,3.643v7.973h20.623v-7.973c0-2.012-.468-3.643-10.312-3.643",
    transform: "translate(-1692.394 -2234.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11720",
    "data-name": "Path 11720",
    className: "cls-12",
    d: "M1859.731,2443.67c-8.266.155-8.908,1.721-8.908,3.63v7.973h10.312c-1-3.97-2.394-7.185-1.4-11.6",
    transform: "translate(-1692.394 -2234.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11721",
    "data-name": "Path 11721",
    className: "cls-10",
    d: "M1861.135,1813.828c9.6,0,10.312-1.631,10.312-3.642v-7.973h-20.623v7.973c0,2.012.469,3.642,10.312,3.642",
    transform: "translate(-1692.394 -1647.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11722",
    "data-name": "Path 11722",
    className: "cls-12",
    d: "M1850.824,1810.185c0,1.69.331,3.111,6.273,3.522-1.4-2.737-1.008-5.081.851-6.674,1.5-1.284,1.271-3.322.809-4.821h-7.933Z",
    transform: "translate(-1692.395 -1647.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11723",
    "data-name": "Path 11723",
    className: "cls-7",
    d: "M1874.776,1922.924c0,1.338-4.463,2.424-9.968,2.424s-9.968-1.086-9.968-2.424,4.463-2.423,9.968-2.423,9.968,1.085,9.968,2.423",
    transform: "translate(-1696.067 -1756.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11724",
    "data-name": "Path 11724",
    className: "cls-6",
    d: "M1863.335,1928.132a12.931,12.931,0,0,1-3.042-4.557c-3.235.4-5.452,1.217-5.452,2.16,0,1.217,3.688,2.224,8.495,2.4",
    transform: "translate(-1696.068 -1758.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11725",
    "data-name": "Path 11725",
    className: "cls-7",
    d: "M1874.776,2400.084c0,1.338-4.463,2.423-9.968,2.423s-9.968-1.085-9.968-2.423,4.463-2.423,9.968-2.423,9.968,1.085,9.968,2.423",
    transform: "translate(-1696.067 -2192.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11726",
    "data-name": "Path 11726",
    className: "cls-6",
    d: "M1854.84,2400.084c0,1.208,3.638,2.21,8.4,2.393a17.471,17.471,0,0,1,1.571-4.817c-5.505,0-9.968,1.085-9.968,2.423",
    transform: "translate(-1696.067 -2192.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11727",
    "data-name": "Path 11727",
    className: "cls-10",
    d: "M1253.963,1631.446s-.118-4.659-.616-11.82c-19.159,9.281-40.268,9.584-54.963,8.1-.109,2.365-.144,3.716-.144,3.716h55.723Z",
    transform: "translate(-1095.671 -1480.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11728",
    "data-name": "Path 11728",
    className: "cls-11",
    d: "M1212.968,1714.962a130.4,130.4,0,0,1-14.585-.658c-.109,2.364-.144,3.716-.144,3.716h14.835a13.212,13.212,0,0,0-.106-3.058",
    transform: "translate(-1095.67 -1567.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11729",
    "data-name": "Path 11729",
    className: "cls-6",
    d: "M1948.029,1.121A9.741,9.741,0,0,0,1948.8,0s-.664.383-1.793.881q.514.113,1.023.238",
    transform: "translate(-1780.343 -0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11730",
    "data-name": "Path 11730",
    className: "cls-6",
    d: "M1548.285,1.2c-8.149-2.951-17.983.552-17.983.552l-.013,9.947s.26-.141.737-.355A35.4,35.4,0,0,1,1548.285,1.2",
    transform: "translate(-1399.297 -0.014)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17344",
    "data-name": "Rectangle 17344",
    className: "cls-7",
    width: 24.772,
    height: 1.867,
    transform: "translate(118.044 222.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11731",
    "data-name": "Path 11731",
    className: "cls-8",
    d: "M1379.3,2622.882h-29.833l2.531-1.868h24.772Z",
    transform: "translate(-1233.951 -2396.657)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17345",
    "data-name": "Rectangle 17345",
    className: "cls-7",
    width: 29.827,
    height: 1.868,
    transform: "translate(115.517 226.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11732",
    "data-name": "Path 11732",
    className: "cls-8",
    d: "M1351.321,2666.523h-35.612l3.021-1.867H1348.3Z",
    transform: "translate(-1203.085 -2436.563)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17346",
    "data-name": "Rectangle 17346",
    className: "cls-7",
    width: 35.524,
    height: 1.868,
    transform: "translate(112.668 229.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11733",
    "data-name": "Path 11733",
    className: "cls-8",
    d: "M1319.62,2710.16h-42.161l3.577-1.867h35.008Z",
    transform: "translate(-1168.11 -2476.464)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17347",
    "data-name": "Rectangle 17347",
    className: "cls-7",
    width: 42.152,
    height: 1.868,
    transform: "translate(109.354 233.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11734",
    "data-name": "Path 11734",
    className: "cls-8",
    d: "M1280.083,2753.8h-50.328l4.27-1.867h41.789Z",
    transform: "translate(-1124.489 -2516.368)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17348",
    "data-name": "Rectangle 17348",
    className: "cls-7",
    width: 50.328,
    height: 1.868,
    transform: "translate(105.266 237.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11735",
    "data-name": "Path 11735",
    className: "cls-8",
    d: "M1232.347,2797.435h-60.188l5.106-1.868h49.976Z",
    transform: "translate(-1071.823 -2556.269)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17349",
    "data-name": "Rectangle 17349",
    className: "cls-7",
    width: 60.188,
    height: 1.868,
    transform: "translate(100.336 241.167)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleSingleCarousel);
export default __webpack_public_path__ + "static/media/temple-single-carousel.8f34dc0be0848f2e0d48cb8343d60f3e.svg";
export { ForwardRef as ReactComponent };